<template><section><!--
注意：具有交互功能的说明文档，需要有<script></script>标签，在标签元素中定义需要导出的vue实例。
在:::demo ::: 代码块中定义的模版<template></template>会作为导出的vue实例的模版，但是在代码块中的<script></script>中的内容仅作为展示，需注意。
-->

<h2>Input</h2>
<p>介绍Input的使用</p>
<demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;&lt;template&gt;\n  &lt;jy-input :value=\&quot;value\&quot;&gt;&lt;/jy-input&gt;\n&lt;/template&gt;\n\n&quot;,&quot;script&quot;:&quot;\nexport default {\n  data () {\n    return {\n      value: '测试测试'\n    }\n  }\n}\n&quot;,&quot;style&quot;:null}">
                            <div class="source" slot="source"><template>
  <jy-input :value="value"></jy-input>
</template>

</div>
                            
                            <div class="highlight" slot="highlight"><pre v-pre=""><code class="hljs language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">jy-input</span>
    <span class="hljs-attr">:value</span>=<span class="hljs-string">"value"</span>
  &gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">jy-input</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">value</span>: <span class="hljs-string">'测试测试'</span>
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
</section></template>

<script>
export default {
  data () {
    return {
      value: '测试测试'
    }
  }
}
</script>


// WEBPACK FOOTER //
// examples/docs/input.vue